import { createContext, ReactNode, useContext, useMemo, useState } from 'react';
import { ListingStatus } from '@steelbuy/ts-shared';

export interface MyListingsContextValue {
    listingFilter: ListingStatus[];
    setListingFilter: (filter: ListingStatus[]) => void;
}

const defaultValue: MyListingsContextValue = {
    listingFilter: [],
    setListingFilter: () => null,
};

const MyListingsContext = createContext(defaultValue);

export const MyListingsContextProvider = ({ children }: { children: ReactNode }) => {
    const [listingFilter, setListingFilter] = useState<ListingStatus[]>([]);

    const value = useMemo(
        () => ({
            listingFilter,
            setListingFilter,
        }),
        [listingFilter, setListingFilter]
    );

    return <MyListingsContext.Provider value={value}>{children}</MyListingsContext.Provider>;
};

export const useMyListingsContext = () => useContext(MyListingsContext);
